// PricingFAQ — FAQ section using shadcn Accordion with scroll-triggered animations

"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_DATA } from "./pricing-data";
export function PricingFAQ() {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      y: 40
    };
    t1 = {
      opacity: 1,
      y: 0
    };
    t2 = {
      once: true,
      margin: "-100px"
    };
    t3 = {
      duration: 0.6
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="text-ds-text-primary mb-2 text-center text-3xl font-medium tracking-tight md:text-4xl">Frequently Asked Questions</h2>;
    t5 = <p className="text-ds-text-muted mb-8 text-center text-base">Everything you need to know about the product and billing.</p>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <motion.section initial={t0} whileInView={t1} viewport={t2} transition={t3} className="mx-auto max-w-[768px] py-16">{t4}{t5}<Accordion type="single" collapsible={true}>{FAQ_DATA.map(_temp)}</Accordion></motion.section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}
function _temp(faq, index) {
  return <motion.div key={faq.question} initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.3,
    delay: index * 0.1
  }}><AccordionItem value={`faq-${index}`}><AccordionTrigger className="text-left text-base font-medium">{faq.question}</AccordionTrigger><AccordionContent className="text-ds-text-subtle dark:text-ds-text-disabled">{faq.answer}</AccordionContent></AccordionItem></motion.div>;
}